// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3BNPd","row":"styles_row__2SZpl"};